export const locales = ['en-US', 'es-ES', 'ja-JP'] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en-US';

export const localeNames: Record<Locale, string> = {
  'en-US': 'English (US)',
  'es-ES': 'Español',
  'ja-JP': '日本語',
};

export function isLocale(value: unknown): value is Locale {
  const candidates: readonly string[] = locales;
  return typeof value === 'string' && candidates.includes(value);
}
